
import './App.css';
import Cardlist from './components/Cardlist';
import Landingpage from './components/Landingpage';
import axios from 'axios';
import { useState } from 'react';

function App() {
    const [genreInput, setGenreInput] = useState("");
    const [cardData, setCardData] = useState([]);

    const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
    const SPOTIFY_CLIENT_ID = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
    const SPOTIFY_CLIENT_SECRET = process.env.REACT_APP_SPOTIFY_CLIENT_SECRET;

    const processBooksAPI = async () => {
        await axios.get(`https://www.googleapis.com/books/v1/volumes?q=subject:${genreInput}&maxResults=10&key=${GOOGLE_API_KEY}`)
            .then(result => {
                setCardData(result.data.items.map(item => ({
                  title: item.volumeInfo.title,
                  imageUrl: item.volumeInfo.imageLinks.thumbnail,
                  releaseDate: item.volumeInfo.publishedDate,
                  genre: item.volumeInfo.categories[0]
                })));
            })
            .catch(error => {
                console.error('Error fetching books:', error);
            });
    };

    const getSpotifyToken = async () => {
        const url = 'https://accounts.spotify.com/api/token';
        const data = 'grant_type=client_credentials';
        const auth = `${SPOTIFY_CLIENT_ID}:${SPOTIFY_CLIENT_SECRET}`;
        const base64Auth = btoa(auth); // Using btoa() to base64 encode the client ID and client secret

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Basic ${base64Auth}` // Updated authorization header
            }
        };

        try {
            const response = await axios.post(url, data, config);
            return response.data.access_token;
        } catch (error) {
            console.error('Error obtaining Spotify access token', error);
        }
    };

    const processMusicAPI = async () => {
      const spotifyToken = await getSpotifyToken(); // Wait for the token to be obtained
      const genreInput = 'YOUR_GENRE_HERE'; // Ensure this is set by the user's input
  
      try {
          const response = await axios.get(`https://api.spotify.com/v1/search`, {
              params: {
                  q: `genre:${genreInput}`, // Modify this line to include genre in the query
                  type: 'track',
                  limit: 10
              },
              headers: {
                  'Authorization': `Bearer ${spotifyToken}`,
                  'Content-Type': 'application/json'
              }
          });
  
          // Process the response data
          setCardData(response.data.tracks.items.map(item => ({
                title: item.name,
                imageUrl: item.album.images[1].url,
                releaseDate: item.album.release_date,
                // genre: item.genre, // Removed because genre is not directly available from the track object
          })));
          console.log(response.data.tracks.items);
      } catch (error) {
          console.error('Error fetching music:', error);
      }
  };
  

  return (
    <div className="App background">
      <Landingpage />
      <input
                className="form-input"
                id={'my-input'}
                type={'text'}
                value={genreInput}
                placeholder={"Need recommendations for what book, music or movie to check out next? Enter a key term to get started..."}
                onChange={event => {
                    setGenreInput(event.target.value);
                }}
            />
      <button className= "button" onClick={processBooksAPI}>Books</button>
      {/* <button className= "button" onClick={processMusicAPI}>Music</button> */}
      <Cardlist data={cardData} />
    </div>
  );
}

export default App;
